import Router from 'vue-router';
import Layout from '@/components/Layout.vue';

export const KitRoutes = [
  {
    path: '/kit/docs/search',
    name: 'Search',
    meta: {
      fqdn: 'search',
    },
    component: Layout,
  },
  {
    path: '/kit/docs',
    name: 'Voximplant Kit',
    meta: {
      fqdn: '',
      title: 'Documentation',
      description:
        'Build smart IVRs, launch automated call campaigns and make trigger outbound calls with our visual flow builder to improve customer experience in no time.',
    },
    component: Layout,
  },
  {
    path: '/kit/docs/references',
    name: 'API Reference',
    meta: {
      fqdn: 'references',
      title: 'API Reference',
      description:
        'Build smart IVRs, launch automated call campaigns and make trigger outbound calls with our visual flow builder to improve customer experience in no time.',
    },
    component: Layout,
  },
];

export function createKitRouter() {
  return new Router({
    linkActiveClass: 'open active',
    mode: 'history',
    routes: KitRoutes,
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });
}
